import { useSelector } from 'react-redux';
import { selectNavigationTab } from '../navigationSlice';

export const useSelectNavigationTab = () => useSelector(selectNavigationTab);
